module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-testInner page-test"
  }, [_c('transition-group', {
    attrs: {
      "name": "fadeIn",
      "appear": ""
    }
  }, _vm._l((_vm.questions), function(quest, num) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.questIndex === num),
        expression: "questIndex === num"
      }],
      key: num,
      staticClass: "quest_item"
    }, [_c('div', {
      staticClass: "lines-wrapper"
    }, [_c('div', {
      ref: "lines1",
      refInFor: true,
      staticClass: "lines1"
    }), _vm._v(" "), _c('div', {
      ref: "lines2",
      refInFor: true,
      staticClass: "lines2"
    })]), _vm._v(" "), _c('div', {
      staticClass: "quest_inner"
    }, [_c('div', {
      staticClass: "quest_head"
    }, [_c('div', {
      staticClass: "col"
    }, [_c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm.formatVal(_vm.time.min)) + ":" + _vm._s(_vm.formatVal(_vm.time.sec)))])]), _vm._v(" "), _c('div', {
      staticClass: "col"
    }, [_c('p', {
      staticClass: "points"
    }, [_vm._v(_vm._s(_vm.points) + "\n\t\t\t\t\t\t\t"), _c('starSvg', {
      staticClass: "star"
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "quest_body"
    }, [_c('p', {
      staticClass: "progress"
    }, [_vm._v(_vm._s((num + 1)))]), _vm._v(" "), _c('p', {
      staticClass: "question"
    }, [_vm._v(_vm._s(quest.question))]), _vm._v(" "), (!!quest.image) ? _c('img', {
      attrs: {
        "src": _vm.$store.getters['GET_URL_ROOT'] + quest.image,
        "alt": ""
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "quest_footer"
    }, _vm._l((quest.answers), function(answer, index) {
      return _c('label', {
        key: index,
        staticClass: "radio_lbl"
      }, [_c('input', {
        attrs: {
          "type": "radio",
          "name": 'quest' + (num + 1)
        },
        on: {
          "change": function($event) {
            _vm.chooseAnswer(quest.id, answer.id)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "mark"
      }), _vm._v(" "), _c('p', {
        staticClass: "text"
      }, [_vm._v(_vm._s(answer.answer))])])
    }))])])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f76911da","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/TestInner.vue
// module id = 518
// module chunks = 1